import { styled } from '../../theme';
import { Paragraph } from '../Paragraph';

export const $Paragraph = styled(Paragraph)`
	text-align: center;
`;
